import { useLayoutEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useCreateTeamMutation, useUploadTeamCoverMutation } from '../../../api/teams'
import { teamFormToPayload, type TeamFormValues } from './ZodValidationSchema'
import type { TDictionaryItem } from '../../../api/types'
import { DraftTeamForm } from './DraftTeamForm'
import { extractApiErrorMessage } from '../../../utils/api'

export const CreateTeam = () => {
  useLayoutEffect(() => {
    document.title = 'Создание команды'
  }, [])

  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [createTeam] = useCreateTeamMutation()
  const [uploadTeamCover] = useUploadTeamCoverMutation()

  const handleSubmit = async (formData: TeamFormValues, focuses: TDictionaryItem[]) => {
    setIsLoading(true)
    try {
      const image = formData.image
      const payload = teamFormToPayload(formData, focuses)
      const { id, slug } = await createTeam({ payload }).unwrap()

      if (!(image instanceof File)) {
        toast.error('Загрузите обложку команды')
        return
      }

      await uploadTeamCover({ teamId: id, file: image }).unwrap()
      toast.success('Команда создана')
      navigate(`../${slug || id}`)
    } catch (error) {
      toast.error(extractApiErrorMessage(error) ?? 'Не удалось создать команду')
    } finally {
      setIsLoading(false)
    }
  }

  return <DraftTeamForm onSubmitDraft={handleSubmit} isLoading={isLoading} />
}
